import apiClient from '../../../common/functions/api_axios_instance.function';

export const saveSystemPoItemDetails = async ({ po_id, items, po_date, po_delivery_date }) => {
  try {
    const response = await apiClient.post(
      '/systemInvoiceManagement/purchaseOrderManagement/po-item-details',
      {
        po_id,
        items,
        po_date: po_date || null,
        po_delivery_date: po_delivery_date || null,
      }
    );

    if (response.status === 200 || response.status === 201) {
      return {
        success: true,
        data: response.data?.response || response.data?.data || response.data,
        message: response.data?.message || 'PO item details saved successfully',
      };
    }

    return {
      success: false,
      status: response.status,
      error: response.data?.message || response.data?.error || 'Failed to save PO item details',
    };
  } catch (error) {
    return {
      success: false,
      status: error?.response?.status,
      error:
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'Failed to save PO item details',
    };
  }
};
